import * as React from 'react'
import styles from './header.module.scss'

const logo = 'https://res.cloudinary.com/albin-groen/image/upload/f_auto/v1585245980/ceroface/logo_1.png'

const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.content}>
        <img src={logo} alt="Logo"/>
      </div>
    </header>
  )
}

export default Header